export const API_URL = 'buffers'
export const ROUTE_NAME = 'buffers'
